import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ReactiveFormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {AksjeeierEnkelModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {AvatarKomponent} from "web-ng2/delt/komponenter/avatar/avatar";
import {TranslateModule} from "@ngx-translate/core";
import {aktiveRollePerioderSomStreng} from "felles-ng2/modell/medlemModellHjelpere";
import {standard} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MedlemInvitasjonsskjemaForAksjeeierSkjemaType} from "web-ng2/moduler/møte/komponenter/generalforsamling-rediger-representasjon/generalforsamling-rediger-representasjoner";
import {DeltakerSkjemaType} from "web-ng2/moduler/møte/komponenter/møte-rediger-deltaker/møte-rediger-deltaker";
import {erInvitasjonSkjema} from "web-ng2/moduler/møte/komponenter/møte-rediger-deltakere-gf/møte-rediger-deltakere-gf";
import {skjemaendringerSomObserverbar} from "felles-ng2/infrastruktur/angular/reactiveForm";
import {toSignal} from "@angular/core/rxjs-interop";
import {map} from "rxjs/operators";
import {standardStreng} from "felles-ng2/støttefunksjoner/strenger";

const debug = initDebugger('MøteRedigerDeltakerGFKontroller');

@Component({
    selector: 'moete-rediger-deltaker-gf',
    templateUrl: './møte-rediger-deltaker-gf.html',
    styleUrls: ['./møte-rediger-deltaker-gf.scss'],
    host: {'data-testid': 'møte-rediger-deltaker-gf'},
    imports: [
        ReactiveFormsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        MatSlideToggleModule,
        AvatarKomponent,
        TranslateModule
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteRedigerDeltakerGFKontroller {

    skjema = input.required<DeltakerSkjemaType | MedlemInvitasjonsskjemaForAksjeeierSkjemaType>();
    /** Samling med aksjeeiere deltakeren representerer */
    aksjeeiere = input.required<AksjeeierEnkelModell[]>();
    skalSignereValgSynlig = input(true);

    erInvitasjon = computed(() => erInvitasjonSkjema(this.skjema()));
    /** dersom invitasjon returnerer navn eller epost om navn ikke er angitt, ellers returnerer navn fra medlem */
    representantensNavn = toSignal(skjemaendringerSomObserverbar(this.skjema).pipe(
      map(verdier => this.erInvitasjon() ?
        standardStreng(this.somInvitasjon().value.nyInvitasjonSkjema!.navn, this.somInvitasjon().value.nyInvitasjonSkjema!.epost!) :
        this.somDeltaker().value.medlem!.navn
      )), {initialValue: ''});
    aktiveMedlemsroller = computed(() => this.beregnAktiveMedlemsroller());

    constructor() {
    }

    somDeltaker(): DeltakerSkjemaType {
        return this.skjema() as DeltakerSkjemaType;
    }

    somInvitasjon(): MedlemInvitasjonsskjemaForAksjeeierSkjemaType {
        return this.skjema() as MedlemInvitasjonsskjemaForAksjeeierSkjemaType;
    }

    // private hjelpemetoder

    private beregnAktiveMedlemsroller(): string {
        if (this.erInvitasjon())
            return standard(this.somInvitasjon().controls.nyInvitasjonSkjema.controls.rolle.value?.tittel, '')

        return aktiveRollePerioderSomStreng(this.somDeltaker().value.medlem!);
    }
}
